(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result-item.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/searchresults/receiver-search-result-item.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.SearchResultItem = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.receiver_generic_item(data);
    },
    templateContext: {
      isCorporateSite: svs.grassroots.data.config.isCorporateSite
    },
    events: {
      'click .js-add-support-btn': 'addSupport',
      'click .js-remove-support-btn': 'removeSupport',
      'click .expandable-box-header-yearlystatistics': 'toggleAllYearlystatistics'
    },
    tagName: 'div',
    className: 'search-result-receiver',
    modelEvents: { 'change:myReceiver': 'render' },
    addSupport: function() {
      var longnameUrl;
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.grassroots.collections.my_receivers.addSupport(this.model, this.el);
      } else {
        longnameUrl = this.model.get('longname');
        svs.grassroots.router.navigate(
          Backbone.history.fragment +
            '&add=' +
            this.model.get('id') +
            '&name=' +
            longnameUrl,
          { silent: true }
        );
        svs.components.customer_login.login();
      }
      return false;
    },

    removeSupport: function(e) {
      e.preventDefault();
      svs.grassroots.collections.my_receivers.removeSupport(this.model);
    },
    toggleAllYearlystatistics: function(e) {
      if (e.currentTarget.innerText === 'Visa fler') {
        e.currentTarget.innerText = 'Visa färre';
      } else {
        e.currentTarget.innerText = 'Visa fler';
      }
      return true;
    }
  });
})(Backbone, _, svs);


 })(window);